export default "__VITE_ASSET__tBCBkriOoDVjTWDvdwJYfg__"